module.exports = __webpack_public_path__ + "img/image-icon.1e1c8d1b.svg";